<div class="px-4 pb-6 flex flex-col gap-4">
  <div class="grid grid-cols-[10%_90%] mr-0.5">
    <a routerLink="/energy-admin">
      <div class="pt-4.0 h-8 w-8" id="performance-back-arrow"></div>
    </a>
    <div>
      <h1 class="pt-2.5">Chart Comparison Debug</h1>
    </div>
  </div>

  <p class="text-sm text-gray-600">
    Paste one dataset into each textarea. Expected row format: <code>node_id timestamp value</code>.
  </p>

  <button class="generate-button" (click)="generateCharts()">
    Generate charts
  </button>

  <div class="grid gap-4 md:grid-cols-2">
    <section class="card">
      <h2>Input 1</h2>
      <textarea
        [(ngModel)]="firstInput"
        class="input-area"
        rows="14"
        placeholder="node_id timestamp value"
      ></textarea>
      <div class="status-text">{{ firstStatus }}</div>
    </section>

    <section class="card">
      <h2>Input 2</h2>
      <textarea
        [(ngModel)]="secondInput"
        class="input-area"
        rows="14"
        placeholder="node_id timestamp value"
      ></textarea>
      <div class="status-text">{{ secondStatus }}</div>
    </section>
  </div>

  <div class="grid gap-4 md:grid-cols-2">
    <section class="card">
      <h2>Chart 1</h2>
      <div class="chart-wrapper">
        <canvas
          baseChart
          [data]="firstChartData"
          [type]="chartType"
          [options]="chartOptions"
        ></canvas>
      </div>
    </section>

    <section class="card">
      <h2>Chart 2</h2>
      <div class="chart-wrapper">
        <canvas
          baseChart
          [data]="secondChartData"
          [type]="chartType"
          [options]="chartOptions"
        ></canvas>
      </div>
    </section>
  </div>

  <section class="card">
    <h2>Comparison Table</h2>
    @if (comparisonRows.length > 0) {
      <div class="table-wrapper">
        <table class="comparison-table">
          <thead>
            <tr>
              <th>Timestamp</th>
              <th>Dataset 1 Value</th>
              <th>Dataset 2 Value</th>
            </tr>
          </thead>
          <tbody>
            @for (row of comparisonRows; track row) {
              <tr>
                <td>{{ formatTimestamp(row.timestamp) }}</td>
                <td [class.non-match]="row.isMismatch">{{ formatValue(row.dataset1Value) }}</td>
                <td [class.non-match]="row.isMismatch">{{ formatValue(row.dataset2Value) }}</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <div class="status-text">Generate charts to see the comparison table.</div>
    }
  </section>
</div>
